/**
 * Created by zad on 17/10/17.
 */

// 自动创建三种action，typename， typename_success, typename_fail
const createTypes = (typename) => {
  const typenameSuccess = `${typename}_SUCCESS`;
  const typenameFail = `${typename}_FAIL`;
  return {
    [typename]: Symbol(typename.toLowerCase()),
    [typenameSuccess]: Symbol(typenameSuccess.toLowerCase()),
    [typenameFail]: Symbol(typenameFail.toLowerCase()),
  };
};

// notebooks
const NOTEBOOKS_INIT = Symbol('notebooks_init');
const GET_NOTEBOOKS = Symbol('get_notebooks');
const GET_NOTEBOOKS_SUCCESS = Symbol('get_notebooks_success');
const GET_NOTEBOOKS_FAIL = Symbol('get_notebooks_fail');
const SORT_NOTEBOOKS = Symbol('sort_notebooks');
const SORT_NOTEBOOKS_SUCCESS = Symbol('sort_notebooks_success');
const SORT_NOTEBOOKS_FAIL = Symbol('sort_notebooks_fail');

// notes
const NOTES_INIT = Symbol('notes_init');
const GET_NOTES = Symbol('get_notes');
const GET_NOTES_SUCCESS = Symbol('get_notes_success');
const GET_NOTES_FAIL = Symbol('get_notes_fail');
const SORT_NOTES = Symbol('sort_notes');
const SORT_NOTES_SUCCESS = Symbol('sort_notes_success');
const SORT_NOTES_FAIL = Symbol('sort_notes_fail');
const GET_COVER_IMG = Symbol('get_cover_img');
const GET_COVER_IMG_SUCCESS = Symbol('get_cover_img_success');
const GET_COVER_IMG_FAIL = Symbol('get_cover_img_fail');
const POST_COVER_IMG = Symbol('post_cover_img');
const POST_COVER_IMG_SUCCESS = Symbol('post_cover_img_success');
const POST_COVER_IMG_FAIL = Symbol('post_cover_img_fail');
const POST_SET_NOTE_TOP = Symbol('post_set_note_top');
const POST_SET_NOTE_TOP_SUCCESS = Symbol('post_set_note_top_success');
const POST_SET_NOTE_TOP_FAIL = Symbol('post_set_note_top_fail');
const POST_UNSET_NOTE_TOP = Symbol('post_unset_note_top');
const POST_UNSET_NOTE_TOP_SUCCESS = Symbol('post_unset_note_top_success');
const POST_UNSET_NOTE_TOP_FAIL = Symbol('post_unset_note_top_fail');
const SET_NOTE_REPRINTABLE = Symbol('set_note_reprintable');
const SET_NOTE_REPRINTABLE_SUCCESS = Symbol('set_note_reprintable_success');
const SET_NOTE_REPRINTABLE_FAIL = Symbol('set_note_reprintable_fail');
const SET_NOTE_PUBLISH_TIME = Symbol('set_note_publish_time');
const SET_NOTE_PUBLISH_TIME_SUCCESS = Symbol('set_note_publish_time_success');

// user
const USER_INIT = Symbol('user_init');
const USER_OTP_CHANNEL_INIT = Symbol('user_opt_chanel_init');
const GET_USER = Symbol('get_user');
const GET_USER_SUCCESS = Symbol('get_user_success');
const GET_USER_FAIL = Symbol('get_user_fail');
const SET_USER = Symbol('set_user');
const CHANGE_EDITOR_TYPE = Symbol('change_editor_type');
const CHANGE_EDITOR_TYPE_SUCCESS = Symbol('change_editor_type_success');
const CHANGE_EDITOR_TYPE_FAIL = Symbol('change_editor_type_fail');
const SET_BIND_STATUS = Symbol('set_bind_status');
const SWITCH_SYNC_SCROLL = Symbol('switch_sync_scroll');
const SWITCH_SYNC_SCROLL_FAIL = Symbol('switch_sync_scroll_fail');

// note-content
const NOTE_CONTENT_INIT = Symbol('note_content_init');
const GET_NOTE_CONTENT = Symbol('get_note_content');
const GET_NOTE_CONTENT_SUCCESS = Symbol('get_note_content_success');
const GET_NOTE_CONTENT_FAIL = Symbol('get_note_content_fail');
const UPDATE_NOTE_CONTENT_ABBR = Symbol('update_note_content_abbr');
const POST_AUDIO = Symbol('post_audio');
const PUT_AUDIO_MESSAGE = Symbol('put_audio_message');
const PUT_AUDIO_MESSAGE_SUCCESS = Symbol('put_audio_message_success');
const PUT_AUDIO_MESSAGE_FAIL = Symbol('put_audio_message_fail');
const GET_AUDIO_URL = Symbol('get_audio_url');
const GET_AUDIO_URL_SUCCESS = Symbol('get_audio_url_success');
const GET_AUDIO_URL_FAIL = Symbol('get_audio_url_fail');

// note-history
const NOTE_HISTORY_INIT = Symbol('note_history_init');
const NOTE_HISTORY_CONTENT_INIT = Symbol('note_history_content_init');
const NOTE_HISTORY_RESTORE_INIT = Symbol('note_history_restore_init');

// trash
const TRASH_NOTES_LIST_INIT = Symbol('trash_noteslist_init');
const TRASH_NOTE_CONTENT_INIT = Symbol('trash_notescontent_init');

// global
const CHANGE_LOCALE = Symbol('change_locale');
const CHANGE_LOCALE_SUCCESS = Symbol('change_locale_success');
const CHANGE_LOCALE_FAIL = Symbol('change_locale_fail');
const SWITCH_DEV = Symbol('switch_dev');
const SET_BIND_PHONE_STATUS = Symbol('set_bind_phone_status');
const SET_PUBLISH_SUCCESS_MODAL_DATA = Symbol('set_publish_success_modal_data');
const SET_QRCODE_MODAL_DATA = Symbol('set_qrcode_modal_data');
const SET_PNAGREE_MODAL_DATA = Symbol('set_pnagree_modal_data');
const CHANGE_READ_MODE = Symbol('change_read_mode');
const CHANGE_READ_MODE_SUCCESS = Symbol('change_read_mode_success');
const CHANGE_READ_MODE_FAIL = Symbol('change_read_mode_fail');
const CHANGE_FONT_TYPE = Symbol('change_font_type');
const CHANGE_FONT_TYPE_SUCCESS = Symbol('change_font_type_success');
const CHANGE_FONT_TYPE_FAIL = Symbol('change_font_type_fail');
const SET_NOTE_DATA = Symbol('set_note_data');
const SET_SORTED_NOTE_DATA = Symbol('set_sorted_note_data');
const SET_BIND_WX_STATUS = Symbol('set_bind_wx_status');
const SET_OCCUPY_HASOTHER = Symbol('set_occupy_hasother');
const SET_OCCUPY_NOOTHER = Symbol('set_occupy_noother');
const OPEN_TIME_PUBLISH_BUY_MODAL = Symbol('open_time_publish_buy_modal');
const CLOSE_TIME_PUBLISH_BUY_MODAL = Symbol('close_time_publish_buy_modal');

export const Notebooks = {
  NOTEBOOKS_INIT,
  GET_NOTEBOOKS,
  GET_NOTEBOOKS_SUCCESS,
  GET_NOTEBOOKS_FAIL,
  SORT_NOTEBOOKS,
  SORT_NOTEBOOKS_SUCCESS,
  SORT_NOTEBOOKS_FAIL,
  ...createTypes('NEW_NOTEBOOK'),
  ...createTypes('DEL_NOTEBOOK_SOFT'),
  ...createTypes('RENAME_NOTEBOOK'),
};

export const Notes = {
  NOTES_INIT,
  GET_NOTES,
  GET_NOTES_SUCCESS,
  GET_NOTES_FAIL,
  SORT_NOTES,
  SORT_NOTES_SUCCESS,
  SORT_NOTES_FAIL,
  ...createTypes('NEW_NOTE'),
  ...createTypes('PUBLISH_NOTE'),
  ...createTypes('UPDATE_NOTE'),
  ...createTypes('PRIVATE_NOTE'),
  ...createTypes('DEL_NOTE_SOFT'),
  ...createTypes('MOVE_NOTE'),
  ...createTypes('PUBLISH_PAID_NOTE'),
  GET_COVER_IMG,
  GET_COVER_IMG_SUCCESS,
  GET_COVER_IMG_FAIL,
  POST_COVER_IMG,
  POST_COVER_IMG_SUCCESS,
  POST_COVER_IMG_FAIL,
  POST_SET_NOTE_TOP,
  POST_SET_NOTE_TOP_SUCCESS,
  POST_SET_NOTE_TOP_FAIL,
  POST_UNSET_NOTE_TOP,
  POST_UNSET_NOTE_TOP_SUCCESS,
  POST_UNSET_NOTE_TOP_FAIL,
  SET_NOTE_REPRINTABLE,
  SET_NOTE_REPRINTABLE_SUCCESS,
  SET_NOTE_REPRINTABLE_FAIL,
  SET_NOTE_PUBLISH_TIME,
  SET_NOTE_PUBLISH_TIME_SUCCESS,
};

export const User = {
  USER_INIT,
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  SET_USER,
  USER_OTP_CHANNEL_INIT,
  ...createTypes('GET_USER_OTP_CHANNEL'),
  CHANGE_EDITOR_TYPE,
  CHANGE_EDITOR_TYPE_SUCCESS,
  CHANGE_EDITOR_TYPE_FAIL,
  SWITCH_SYNC_SCROLL,
  SWITCH_SYNC_SCROLL_FAIL,
};

export const NoteContent = {
  NOTE_CONTENT_INIT,
  GET_NOTE_CONTENT,
  GET_NOTE_CONTENT_SUCCESS,
  GET_NOTE_CONTENT_FAIL,
  UPDATE_NOTE_CONTENT_ABBR,
  POST_AUDIO,
  PUT_AUDIO_MESSAGE,
  PUT_AUDIO_MESSAGE_SUCCESS,
  PUT_AUDIO_MESSAGE_FAIL,
  GET_AUDIO_URL,
  GET_AUDIO_URL_SUCCESS,
  GET_AUDIO_URL_FAIL,
  ...createTypes('DELETE_AUDIO'),
};

export const Global = {
  CHANGE_LOCALE,
  CHANGE_LOCALE_SUCCESS,
  CHANGE_LOCALE_FAIL,
  SWITCH_DEV,
  SET_BIND_PHONE_STATUS, // 控制绑定手机的modal的显示隐藏
  SET_PUBLISH_SUCCESS_MODAL_DATA,
  SET_QRCODE_MODAL_DATA,
  SET_BIND_WX_STATUS,
  SET_PNAGREE_MODAL_DATA, // 设置付费协议弹窗数据
  CHANGE_READ_MODE,
  CHANGE_READ_MODE_FAIL,
  CHANGE_READ_MODE_SUCCESS,
  CHANGE_FONT_TYPE,
  CHANGE_FONT_TYPE_SUCCESS,
  CHANGE_FONT_TYPE_FAIL,
  SET_NOTE_DATA, // 发布文章的数据
  SET_BIND_STATUS,
  SET_SORTED_NOTE_DATA, // 移动文章的数据
  SET_OCCUPY_HASOTHER,
  SET_OCCUPY_NOOTHER,
  OPEN_TIME_PUBLISH_BUY_MODAL,
  CLOSE_TIME_PUBLISH_BUY_MODAL,
};

export const NoteHistory = {
  NOTE_HISTORY_INIT,
  ...createTypes('GET_NOTE_HISTORY_LIST'),
  NOTE_HISTORY_CONTENT_INIT,
  ...createTypes('GET_NOTE_HISTORY_CONTENT'),
  NOTE_HISTORY_RESTORE_INIT,
  ...createTypes('RESTORE_NOTE_HISTORY_CONTENT'),
};

export const Trash = {
  TRASH_NOTES_LIST_INIT,
  TRASH_NOTE_CONTENT_INIT,
  ...createTypes('GET_TRASH_NOTES_LIST'),
  ...createTypes('GET_TRASH_NOTE_CONTENT'),
  ...createTypes('DEL_TRASH_NOTE'),
  ...createTypes('RECOVERY_TRASH_NOTE'),
};



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js